import { PolicyInputType } from "../types/builder";
import { ApiValueType } from "../types/policyForm";

export function mapInputTypeToApiValueType(
  inputType: PolicyInputType,
): ApiValueType | undefined {
  switch (inputType) {
    case "SELECT":
    case "SELECT_DYNAMIC":
      return "select";
    case "MULTI_SELECT":
      return "multi_select";
    case "NUMBER":
      return "number";
    case "SWITCH":
    case "BOOLEAN":
      return "boolean";
    default:
      return undefined;
  }
}
